var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.snackbar.display,"color":_vm.snackbar.color,"right":""},on:{"input":_vm.closeSnackbar},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.closeSnackbar}},'v-btn',attrs,false),[_vm._v("Fermer")])]}}])},[_vm._v(" "+_vm._s(_vm.snackbar.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }